import React from 'react';
import { Link } from 'react-router';
import { AssetUrls } from 'config/assets';
import './EliteUpsellBanner.css';

interface EliteUpsellBannerProps {
  earnedCount: number;
}

const EliteUpsellBanner: React.FC<EliteUpsellBannerProps> = ({ earnedCount }) => {
  if (earnedCount < 2) return null;

  return (
    <div className="elite-upsell-banner">
      <div className="elite-upsell-banner__text">
        <span className="elite-upsell-banner__headline">
          You've earned {earnedCount} badges!
        </span>
        <span className="elite-upsell-banner__sub">
          Upgrade to Elite to showcase up to 8.
        </span>
      </div>
      <Link to="/elite?source=trophy-case" className="elite-upsell-banner__link">
        <img
          src={AssetUrls.icons.elite.badge}
          alt="Elite"
          width={18}
          height={18}
          className="elite-upsell-banner__elite-icon"
        />
        Learn More
      </Link>
    </div>
  );
};

export default EliteUpsellBanner;
